import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"

export default styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  height: calc(100% - 19px);
  width: calc(100% - 16px);
  border-radius: 3px;
  margin-top: 4px;
  background-color: rgba(0, 0, 0, 0.7);

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    width: calc(100% - 10px);
  `}

  img {
    width: 70px;
    margin-bottom: 16px;
  }
`

export const BodyWithShadow = styled(Body)`
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.77);
`
